
import React from "react";
import axios from "axios";
import { Box, Grid } from "@mui/material";
import SaveAltIcon from '@mui/icons-material/SaveAlt';

export const DiseñoDos = ({ producto, categoria }) => {
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const capacidades = [
    producto.capacidad,
    producto.capacidad1,
    producto.capacidad2,
    producto.capacidad3,
    producto.capacidad4,
    producto.capacidad5,
    producto.capacidad6,
    producto.capacidad7,
    producto.capacidad8,
  ].filter(Boolean);
  const handleDescargar = () => {
    if (producto.pdf) {
      const url = `${backendURL}/${producto.pdf}`;
      window.open(url, '_blank');
    }
  };

  const descargar = async () => {
    if (!producto.id) return;

    try {
      const url = `${backendURL}/api/producto/${producto.id}/descargar-pdf`;

      const response = await axios.get(url, {
        responseType: 'blob', // importante para archivos binarios
      });
      handleDescargar();
      // Crear un blob con el tipo correcto
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Crear un enlace para descargar
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(pdfBlob);

      // Nombre del archivo (puedes personalizarlo)
      link.download = 'ficha-tecnica.pdf';

      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error al descargar PDF:', error);
    }
  };
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: 'center',
          justifyContent: 'center',

        }}>
        <h1 className="TituloPaginaProducto">{categoria.titulo}</h1>
        <h1 className="Titulo1PaginaProducto">{categoria.titulo1}</h1>
      </Box>

      <Box sx={{
        marginTop: '100px',
        '@media (max-width:600px)': {
          marginTop: '30px',
        },
      }}>
        <Grid container spacing={2}>
          <Grid size={{ sm: 12, md: 6 }} sx={{

            display: "flex", alignItems: 'center', justifyContent: 'center', flexDirection: 'column'
          }}>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-end'
              }}>
              {producto.logo_empresa_maquina && (
                <Box
                  className='ImagenLogoEmpresaMaquinaPaginaEspecificas'
                  sx={{
                    display: "none",
                    '@media (max-width:899px)': {
                      display: "flex"
                    },
                  }}

                >
                  <img
                    src={`${backendURL}/${producto.logo_empresa_maquina}`}
                    alt="logo"
                    title="logo"

                  />
                </Box>
              )}
            </Box>
            <Box className='ImagenProdcutoPaginaEspecificas'>
              <div className="imagendiseño2">
                {producto.imagen_producto && (
                  <img
                    src={`${backendURL}/${producto.imagen_producto}`}
                    alt="hod"
                    title="hod"
                  />
                )}
              </div>
            </Box>




          </Grid>
          <Grid size={{ sm: 12, md: 6 }}>
            <Box>
              {/* imagen logo maquina */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: "center",
                  justifyContent: "flex-end"
                }}>

              </Box>
              {/* informacion producto */}
              <Box className='infoProductoMaquina'>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: "center",
                    justifyContent: "flex-end"
                  }}>
                  <Box className='ImagenLogoEmpresaMaquinaPaginaEspecificas' sx={{
                    display: "flex",
                    '@media (max-width:899px)': {
                      display: "none"
                    },
                  }}
                  >
                    {producto.logo_empresa_maquina && (
                      <img
                        src={`${backendURL}/${producto.logo_empresa_maquina}`}
                        alt="hod"
                        title="hod"
                      />
                    )}
                  </Box>
                </Box>
                <Box className='contienetitulomaquinaprodcutopagina'>
                  <h1 className="titulomaquinapaginaespecifico">{producto.titulo_maquina}</h1>
                  <h1 className="titulo1maquinapaginaespecifico" style={{ color: producto.color || '#1A425B' }}>{producto.nombre_maquina}</h1>
                </Box>

                <Box
                  sx={{
                    width: '90%',
                    marginTop: '50px',
                    display: 'flex',
                    '@media (max-width:408px)': {
                      width: '100%',
                    },
                  }}>

                  <Box
                    sx={{
                      width: '4px',
                      backgroundColor: producto.color || '#1A425B',
                      borderRadius: '4px  4px',
                      margin: '10px'
                    }}
                  />
                  <Box className="cardvisionproducto">
                    <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                      {capacidades.map((item) => (
                        <li className="descripciondetalladomaquina"  >
                          <span style={{ color: producto.color || '#1A425B', marginRight: "6px", }}>▶</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </Box>



                </Box>

                <Box
                  sx={{
                    width: '70%',
                    marginTop: '30px',
                    display: 'flex',
                    '@media (max-width:408px)': {
                      width: '100%',
                    },
                  }}>



                </Box>

              </Box>
            </Box>
          </Grid>

        </Grid>
      </Box>
      <Box
        sx={{
          mt: 20,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        {producto.pdf && (
          <button
            onClick={descargar}
            className="anchobotondescarga"
            style={{
              '--boton-color': producto.color || '#1A425B',
            }}
          >
            <SaveAltIcon sx={{ marginRight: '10px', fontSize: '2rem' }} />
            <p style={{ margin: 0 }}>Descargar ficha técnica</p>
          </button>
        )}
      </Box>
    </Box>
  )
}